import type { ReactElement } from 'react';
import CalendarMonthRoundedIcon from '@mui/icons-material/CalendarMonthRounded';
import CompareArrowsRoundedIcon from '@mui/icons-material/CompareArrowsRounded';
import EmojiEventsRoundedIcon from '@mui/icons-material/EmojiEventsRounded';
import EventRepeatRoundedIcon from '@mui/icons-material/EventRepeatRounded';
import GroupsRoundedIcon from '@mui/icons-material/GroupsRounded';
import HistoryRoundedIcon from '@mui/icons-material/HistoryRounded';
import type { TabConfigItem } from '../../../@types';
import type { PreMatchWidgetSection, PreMatchWidgetStandingsView, PreMatchWidgetTabId, StandingZone } from './types';

export const PRE_MATCH_WIDGET_TABS: TabConfigItem<PreMatchWidgetTabId>[] = [
  { label: 'Preview / Summary', value: 'preview-summary' },
  { label: 'Standings', value: 'standings' },
  { label: 'Lineups', value: 'lineups' },
  { label: 'Head 2 Head', value: 'head-to-head' },
  { label: 'Last 5 Matches', value: 'last-5-matches' },
  { label: 'Next 5 Matches', value: 'next-5-matches' },
];

export const INDIVIDUAL_PRE_MATCH_SPORT_IDS = new Set(['3', '6', '8', '14', '20', '28', '36']);
export const INDIVIDUAL_PRE_MATCH_HIDDEN_TABS = new Set<PreMatchWidgetTabId>([
  'standings',
  'lineups',
  'next-5-matches',
]);

export const PRE_MATCH_WIDGET_TAB_LABEL_KEYS: Record<PreMatchWidgetTabId, string> = {
  'preview-summary': 'preMatchWidget.tabs.previewSummary',
  standings: 'preMatchWidget.tabs.standings',
  lineups: 'preMatchWidget.tabs.lineups',
  'head-to-head': 'preMatchWidget.tabs.headToHead',
  'last-5-matches': 'preMatchWidget.tabs.last5Matches',
  'next-5-matches': 'preMatchWidget.tabs.next5Matches',
};

export const DEFAULT_PRE_MATCH_WIDGET_SECTION_ORDER: PreMatchWidgetSection[] = [
  'competition',
  'tournament',
  'content',
  'tabs',
];

export const PRE_MATCH_WIDGET_TAB_ICONS: Record<PreMatchWidgetTabId, ReactElement> = {
  'preview-summary': <CalendarMonthRoundedIcon fontSize='small' />,
  standings: <EmojiEventsRoundedIcon fontSize='small' />,
  lineups: <GroupsRoundedIcon fontSize='small' />,
  'head-to-head': <CompareArrowsRoundedIcon fontSize='small' />,
  'last-5-matches': <HistoryRoundedIcon fontSize='small' />,
  'next-5-matches': <EventRepeatRoundedIcon fontSize='small' />,
};

export const STANDINGS_VIEW_TABS: { label: string; value: PreMatchWidgetStandingsView }[] = [
  { label: 'League', value: 'league' },
  { label: 'Home', value: 'home' },
  { label: 'Away', value: 'away' },
];

export const STANDINGS_VIEW_TAB_LABEL_KEYS: Record<PreMatchWidgetStandingsView, string> = {
  league: 'preMatchWidget.standings.views.league',
  home: 'preMatchWidget.standings.views.home',
  away: 'preMatchWidget.standings.views.away',
};

export const STANDINGS_VIEW_TITLE_KEYS: Record<PreMatchWidgetStandingsView, string> = {
  league: 'preMatchWidget.standings.titles.league',
  home: 'preMatchWidget.standings.titles.home',
  away: 'preMatchWidget.standings.titles.away',
};

export const STANDINGS_LEGEND_LABEL_KEYS: Record<Exclude<StandingZone, 'neutral'>, string> = {
  champions: 'preMatchWidget.standings.legend.champions',
  europa: 'preMatchWidget.standings.legend.europa',
  conference: 'preMatchWidget.standings.legend.conference',
  relegation: 'preMatchWidget.standings.legend.relegation',
};
